import * as DrivingActions from '../actions/driving.actions';
import { StartRoute } from '../../../shared/models/startRoute';
import { RouteDetails } from '../../../shared/models/route-details';

export interface State {
  driving: StartRoute;
  route: RouteDetails;
  error: any;
}

export const initialState: State = {
  driving: null,
  route: null,
  error: null
};

export function reducer(
  state = initialState,
  action: DrivingActions.DrivingActionsUnion
): State {
  switch (action.type) {
    case DrivingActions.getRouteSuccess.type: {
      return {
        ...state,
        route: action.route,
        error: null
      };
    }
    case DrivingActions.stopRouteSuccess.type: {
      const driving = {...state.driving};
      driving.dateTo = action?.data?.dateTo;
      return {
        ...state,
        driving: driving
      };
    }
    case DrivingActions.getDrivingSuccess.type: {
      return {
        ...state,
        driving: action.data
      };
    }
    case DrivingActions.getRouteFailure.type:
    case DrivingActions.stopRouteFailure.type:
    case DrivingActions.getDrivingFailure.type: {
      return {
        ...state,
        error: action.error
      };
    }
    case DrivingActions.clearRoute.type: {
      return {
        ...state,
        driving: null,
        error: null,
        route: null
      };
    }
    default: {
      return state;
    }
  }
}

export const getDriving = (state: State) => state.driving;
export const getDrivingRoute = (state: State) => state.route;
